import React, { Suspense, lazy } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ContentProvider } from './content/ContentContext';
import Home from './pages/Home';
import LegalPage from './pages/LegalPage';

// Admin wird nur geladen, wenn jemand /admin öffnet
const AdminApp = lazy(() => import('./pages/admin/AdminApp'));

const App: React.FC = () => (
  <ContentProvider>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/impressum" element={<LegalPage kind="impressum" />} />
        <Route path="/datenschutz" element={<LegalPage kind="datenschutz" />} />
        <Route
          path="/admin/*"
          element={
            <Suspense fallback={<div className="flex min-h-screen items-center justify-center text-fg-3">Lädt…</div>}>
              <AdminApp />
            </Suspense>
          }
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  </ContentProvider>
);

export default App;
